export function isSessionInactive(sessionLengthInMinutes = 30) {
    let lastActive = null;
    try {
        lastActive = localStorage.getItem("glean_session_last_active");
    }
    catch (e) {
        console.warn(e);
    }
    const lastActiveDate = new Date(Number(lastActive));
    const inactiveThreshold = new Date();
    inactiveThreshold.setMinutes(inactiveThreshold.getMinutes() - sessionLengthInMinutes);
    return inactiveThreshold > lastActiveDate;
}
